exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".job-detail-header[data-v-e471d94a]{padding:10px;border-bottom:1px solid #d0d0d0;height:30px}.job-detail-header .job-detail-title[data-v-e471d94a]{height:30px;line-height:30px}.job-detail-header .job-detail-title .status-tag[data-v-e471d94a]{font-size:12px;margin-left:5px}.job-detail-header .job-detail-title .job-span[data-v-e471d94a]{font-weight:700;font-size:16px;color:#777}.job-detail-header>[data-v-e471d94a]{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-e471d94a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/job_detail/job_detail.vue
// module id = 1006
// module chunks = 1